// DTM
import React from "react";
import styled from "styled-components";

import ArticleAbstract from "./ArticleAbstract";

const Line = styled.div`
  width: 100%;
  float: left;

  border-bottom: solid 1px #e5e5e5;

  margin: 25px 0;

  @media (max-width: 1100px) {
    margin: 25px 0;
  }
  @media (max-width: 700px) {
    margin: 5px 0;
  }
`;

class Border extends ArticleAbstract {
  // image
  // title
  // body
  // meta
  render() {
    return <Line />;
  }
}

export default Border;



// WEBPACK FOOTER //
// ./src/components/Border.js